import BaseApi from './BaseApi'
import chunk from 'lodash/chunk'

class TimesheetApi extends BaseApi {
  createTimesheet (schema_id, month, last_calc_day) {
    return this.post('company/timeSheets/create', { schema_id, month, last_calc_day })
  }

  saveTimesheet (schema_id, month, days) {
    return this.post('company/timeSheets/save', { schema_id, month, days })
  }

  getTimesheet (timesheetId) {
    return this.get(`company/timeSheets/${timesheetId}`)
  }

  deleteTimesheet (timesheetId) {
    return this.delete(`company/timeSheets/${timesheetId}`)
  }

  getSchema (employeeId) {
    return this.get(`company/timeSheets/schema?employee_id=${employeeId}`)
  }

  editSchema (schemaId, schemaObj) {
    return this.put(`company/timeSheets/schema/${schemaId}`, schemaObj)
  }

  editTimesheet (timesheetId, schema_id, month, days) {
    return this.put(`company/timeSheets/${timesheetId}`, {
      schema_id,
      month,
      days
    })
  }

  setSchema (schemaObj) {
    return this.post('company/timeSheets/schema', schemaObj)
  }

  getMonthsWithTimesheets () {
    return this.get('company/timeSheets/months')
  }

  async chunkedRequest (chunks, callback) {
    const resultSet = []
    const firstChunk = chunks.shift()
    const doRequest = callback(resultSet)
    await doRequest(firstChunk)
    Promise.all(chunks.map(doRequest))

    return resultSet
  }

  async batchMultiEmployees (batchData) {
    const chunks = chunk(batchData.schemas, 5)

    const doRequest = (resultSet) => async (schemaChunk) => {
      const { schemas } = await this.post('company/timeSheets/batch/users', { ...batchData, schemas: schemaChunk })
      schemas.forEach(el => resultSet.push(el))
    }
    return this.chunkedRequest(chunks, doRequest)
  }

  async batchMultiMonths (batchData) {
    const chunks = chunk(batchData.months, 5)
    const doRequest = (resultSet) => async (schemaChunk) => {
      const { months } = await this.post('company/timeSheets/batch/months', { ...batchData, months: schemaChunk })
      months.forEach(el => resultSet.push(el))
      resultSet.sort((a, b) => {
        const da = +new Date(a.month.split('-').reverse().join('-'))
        const db = +new Date(b.month.split('-').reverse().join('-'))
        // sort result set after each change
        return da - db
      })
    }

    return this.chunkedRequest(chunks, doRequest)
  }

  batchDeleteTimesheets (ids) {
    return this.delete('/company/timeSheets/batch/delete', { ids })
  }

  allocateHoursForPartTimeWorker (month, schema_id, actual_hours, ignore_last_6_days) {
    const queryString = Object.entries({ month, schema_id, actual_hours, ignore_last_6_days })
      .map(([key, value]) => `${key}=${value}`)
      .join('&')

    return this.get(`company/employees/partTime/calculateHours?${queryString}`)
  }

  archiveMultiEmployees (batchData) {
    return this.put('company/timeSheets/batch/users/save', batchData)
  }

  archiveMultiMonths (batchData) {
    return this.put('company/timeSheets/batch/months/save', batchData)
  }

  downloadTimesheetsOfMonth (month) {
    return this.get(`/company/archives/${month}`)
  }

  downloadLinkForTimesheet (timesheetId, fileName) {
    const url = `company/timeSheets/download/${timesheetId}`
    const method = 'get'
    this.downloadAsFile(
      { url, method },
      'application/pdf',
      fileName
    )
  }
}

export default new TimesheetApi()
